<template>
  <div style="height: 100%">
    <div
      style="height: 100%"
      :class="{
        'card box-shadow2': !isDarkMode,
        'card bg-dark text-light': isDarkMode
      }"
    >
      <h3 class="text-center page-title">{{ title }}</h3>
      <b-table
        fixed
        responsive="sm"
        small
        :items="items"
        :fields="adjustedFields"
        :class="{
          '': !isDarkMode,
          'bg-dark text-light': isDarkMode
        }"
      >
        <template #cell(denomination)="data">
          <span
            :class="{
              'text-dark': !isDarkMode,
              'text-light': isDarkMode
            }"
          >
            {{ formatCurrency(data.item.denomination) }}
          </span>
        </template>
        <template #cell(quantity)="data">
          <b-form-input
            :class="{
              ' bg-light text-dark': !isDarkMode,
              'bg-dark text-light placeholder-light': isDarkMode
            }"
            v-model="data.item.quantity"
            type="number"
            @input="updateTotalAmount(data.item)"
            :disabled="isSubmitted"
          ></b-form-input>
        </template>
        <template #cell(total_amount)="data">
          <span
            :class="{
              'text-dark': !isDarkMode,
              'text-light': isDarkMode
            }"
          >
            {{ formatCurrency(calculateTotalAmount(data.item)) }}
          </span>
        </template>
      </b-table>
      <div class="container d-flex justify-content-between border">
        <p class="">Grand Total</p>
        <p>{{ formatCurrency(grandTotal) }}</p>
      </div>
      <div v-if="isMainCashVisible" class="container d-flex justify-content-between border">
        <p>{{ mainCashText }}</p>
        <p>{{ formatCurrency(mainCash) }}</p>
      </div>
      <div v-if="isDifferenceVisible" class="container d-flex justify-content-between border">
        <p>{{ differenceText }}</p>
        <p>{{ formatCurrency(difference) }}</p>
      </div>
      <div v-if="isRemarkVisible" class="container d-flex justify-content-between align-items-center border">
        <p>Remark:</p>
        <span class="container m-2">
          <b-form-textarea
            :disabled="isSubmitted"
            :class="{
              'bg-light text-dark': !isDarkMode,
              'bg-dark text-light placeholder-light': isDarkMode,
              'border-danger': isValidRemark,
              'border-secondary': !isValidRemark
            }"
            v-model="localRemark"
            @input="updateRemark"
          ></b-form-textarea>
          <span v-if="isValidRemark" class="text-danger">Required</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CashCertificateBox',
  props: {
    title: String,
    items: Array,
    isDarkMode: Boolean,
    isSubmitted: Boolean,
    mainCash: Number,
    difference: Number,
    remark: String,
    isMainCashVisible: Boolean,
    isDifferenceVisible: Boolean,
    isRemarkVisible: Boolean,
    isValidRemark: Boolean,
    mainCashText: {
      type: String,
      default: 'Main Cash as per the DC1 report (Actual)'
    },
    differenceText: {
      type: String,
      default: 'Difference'
    }
  },
  data() {
    return {
      fields: [
        { key: 'denomination', label: 'Denomination' },
        { key: 'quantity', label: 'Quantity', editable: true },
        { key: 'total_amount', label: 'Total' }
      ],
      localRemark: ''
    };
  },
  methods: {
    updateTotalAmount(item) {
      item.total_amount = this.calculateTotalAmount(item);
      this.$emit('update-total');
    },
    calculateTotalAmount(item) {
      return item.denomination * item.quantity;
    },
    formatCurrency(value) {
      if (isNaN(value)) {
        return '₹ NaN';
      }
      return `₹ ${value}`;
    },
    updateRemark() {
      this.$emit('update-remark', this.localRemark);
    }
  },
  computed: {
    adjustedFields() {
      return this.fields.map(field => ({
        ...field,
        variant: this.isDarkMode ? 'dark' : null
      }));
    },
    grandTotal() {
      return this.items.reduce((total, item) => {
        return total + this.calculateTotalAmount(item);
      }, 0);
    }
  },
  watch: {
    remark(newVal) {
      this.localRemark = newVal;
    }
  }
};
</script>
<style>
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0;
}
</style>
